<template>
    <div class="goodLi">
        <div class="radio">
            <input class="doRadio" type="radio" name="cartId" :checked="goodData.checked" @click="editCheck" :disabled='goodData.disabled || (goodData.inventory < goodData.orderMinCount)' v-if="type">
            <input class="doRadio" type="checkbox" name="cartId" :checked="goodData.checked" @click="editCheck" :disabled='goodData.inventory < goodData.orderMinCount' v-else>
            <label></label>
        </div>
        <div class="img" @click="handleDetail">
            <img :src="goodData.imgUrl" alt="">
        </div>
        <div class="content">
            <div class="title" @click="handleDetail" v-text="goodData.skuShowName"></div>
            <div class="bottom" @click="handleDetail" v-if="type">
                <div class="price col999">销售价: ¥{{goodData.salePrice}}</div>
                <div class="groupPrice">
                    <span class="colFF7A45">组合价: ¥{{goodData.minTyingPrice}}起</span>
                    <span class="col999" v-if="goodData.remainingStock >= goodData.orderMinCount">限购1件</span>
                    <span class="colFF7A45" v-else>库存不足</span>
                </div>
            </div>
            <div class="bottom" v-else>
                <div class="price col999">销售价: ¥{{goodData.salePrice}}
                    <div class="cartNum" v-if="goodData.inventory >= goodData.orderMinCount">
                        <p>限购{{goodData.purchaseLimit}}件</p>
                        <van-stepper v-if="$isPriceShow()" v-model="goodData.quantity" input-width="32px" :min='goodData.orderMinCount' :max="countData()" @plus='handleButton' @minus='handleButton' @change='handleButton' integer />
                    </div>
                    <div class="cartNum cartNum2" v-else>库存不足</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        goodData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        type: {
            type: String,
            default: ''
        }
    },
    methods: {
        countData () {
            let goodData = this.goodData
            return goodData.quantity > goodData.inventory ? goodData.inventory : (goodData.inventory > goodData.orderMinCount) ? goodData.inventory : goodData.orderMinCount
        },
        editCheck () {
            this.$emit('editCheck')
        },
        handleButton () {
            this.$emit('handleButton')
        },
        handleDetail () {
            this.$emit('handleDetail')
        }
    }
}
</script>

<style lang="scss" scoped>
.goodLi {
    display: flex;
    justify-content: space-around;
    margin-bottom: 32px;
    .radio {
        flex: 0 0 40px;
        display: flex;
        align-items: center;
        margin-right: 24px;
        input {
            position: absolute;
            padding: 0;
            margin: 0;
            width: 40px;
            height: 40px;
        }
    }
    .img {
        flex: 0 0 160px;
        height: 160px;
        border: 2px solid #f5f5f5;
        margin-right: 16px;
        border-radius: 8px;
        background: #fafafa;
        display: flex;
        img {
            justify-self: center;
            align-self: center;
            margin: 0 auto;
        }
    }
    .content {
        font-size: 24px;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        .title {
            flex: 0 0 100%;
            font-size: 28px;
            color: #000000;
            line-height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
        }
        .bottom {
            flex: 0 0 100%;
            padding-bottom: 12px;
        }
        .price {
            // margin: 10px 0;
            text-decoration: line-through;
            position: relative;
            .cartNum {
                position: absolute;
                right: 0;
                top: -40px;
                p {
                    font-size: 24px;
                    text-align: right;
                }
            }
            .cartNum2 {
                top: 0;
                color: #ff8352;
            }
        }
        .groupPrice {
            display: flex;
            justify-content: space-between;
        }
    }
}
input[type="checkbox"][disabled="disabled"] + label::before,
input[type="radio"][disabled="disabled"] + label::before {
    background: url("../../../../assets/img/b2b/radiobox_copy.png") no-repeat;
    background-size: 100%;
}
input[type="radio"]:checked + label::before {
    background-clip: content-box;
    background: url("../../../../assets/img/b2b/radiobox@2x.png") no-repeat;
    background-size: 100%;
}
/deep/ .van-stepper__plus::after,
/deep/ .van-stepper__plus::before {
    background: none;
    width: 0;
}
/deep/ .van-stepper__minus::before,
/deep/ .van-stepper__plus::before {
    height: 0;
}
/deep/ .van-stepper__minus {
    width: 48px;
    height: 48px;
    background: url("../../../../assets/img/b2b/btnReduce2.png") no-repeat;
    background-size: 100% 100%;
    color: aliceblue;
}
/deep/ .van-stepper__plus {
    width: 48px;
    height: 48px;
    background: url("../../../../assets/img/b2b/btnAdd.png") no-repeat;
    background-size: 100% 100%;
    color: aliceblue;
}
/deep/ .van-stepper__input {
    width: 64px;
    height: 48px;
    background: rgba(255, 118, 69, 0.2);
    border-radius: 4px;
    font-size: 24px;
    color: #323232;
}
/deep/ .van-stepper__minus--disabled {
    width: 48px;
    height: 48px;
    background: url("../../../../assets/img/b2b/btnReduce1.png") no-repeat;
    background-size: 100% 100%;
}
/deep/ .van-stepper__plus--disabled {
    width: 48px;
    height: 48px;
    background: url("../../../../assets/img/b2b/btnAdd1.png") no-repeat;
    background-size: 100% 100%;
}
</style>
